import React from 'react';

import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import ImportableImageGrid from '~/components/Offers/Detail/OfferBuilder/Content/ImagesVideo/OfferGallery/ImportableImageGrid';

import useLpcPropertyImageSync from '~/hooks/apis/offers/useLpcPropertyImageSync';

interface Props {
  propertyId?: string;
  propertyName?: string;
  offerImages: Array<{ id_cloudinary_external: string }>;
  onAddImage: (cloudinaryId: string) => Promise<unknown>;
}

// Sync/Import property images for LPC (tactical_ao_hotel) offers
export default function LpcImageSyncControls({ propertyId, propertyName, offerImages, onAddImage }: Props) {
  const {
    syncTopPropertyImageCount,
    isSyncCapReached,
    isSyncingPropertyImages,
    isLoadingImportImages,
    isImportingSelectedImages,
    isImportImagesModalVisible,
    importableImages,
    alreadyOnOfferIdSet,
    selectedImportImageIds,
    syncTopPropertyImages,
    showImportImagesModal,
    hideImportImagesModal,
    toggleImportImageSelection,
    importSelectedPropertyImages,
  } = useLpcPropertyImageSync({ propertyId, propertyName, offerImages, onAddImage });

  return (
    <>
      <Button
        startIcon={<SyncOutlinedIcon />}
        onClick={syncTopPropertyImages}
        disabled={isSyncingPropertyImages || isSyncCapReached}
      >
        {isSyncingPropertyImages ? 'Syncing…' : `Sync first ${syncTopPropertyImageCount} images`}
      </Button>
      <Button
        startIcon={<AddPhotoAlternateOutlinedIcon />}
        onClick={showImportImagesModal}
        disabled={isLoadingImportImages}
      >
        {isLoadingImportImages ? 'Loading…' : 'Import images'}
      </Button>
      <Dialog open={isImportImagesModalVisible} onClose={hideImportImagesModal} maxWidth="md" fullWidth>
        <DialogTitle>Import images from property</DialogTitle>
        <DialogContent dividers>
          <ImportableImageGrid
            images={importableImages}
            existingImageIdSet={alreadyOnOfferIdSet}
            selectedImageIds={selectedImportImageIds}
            onToggleSelected={toggleImportImageSelection}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={hideImportImagesModal}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={selectedImportImageIds.length === 0 || isImportingSelectedImages}
            onClick={importSelectedPropertyImages}
          >
            {isImportingSelectedImages
              ? 'Importing…'
              : `Import${selectedImportImageIds.length > 0 ? ` (${selectedImportImageIds.length})` : ''}`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
